<template>
    <v-card class="workspace-dashboard__activity-card" elevation="0">
        <div class="workspace-dashboard__section-head workspace-dashboard__section-head--compact">
            <div class="workspace-dashboard__section-kicker">Workspace Activity</div>
            <v-btn variant="text" :href="activityUrl">
                View all activity
            </v-btn>
        </div>
        <div class="workspace-dashboard__feed-list">
            <article
                v-for="item in displayActivityItems"
                :key="`${item.title}-${item.meta}`"
                class="workspace-dashboard__feed-item"
            >
                <span class="workspace-dashboard__feed-icon" :class="`tone-${item.tone}`">
                    <v-icon size="16">{{ activityIcon(item.tone) }}</v-icon>
                </span>
                <div>
                    <strong>{{ item.title }}</strong>
                    <p>{{ item.meta }}</p>
                </div>
                <small>{{ item.timeLabel || 'Recent' }}</small>
            </article>
        </div>
    </v-card>
</template>

<script>
export default {
    name: 'DashboardActivityFeed',
    props: {
        activityItems: {
            type: Array,
            default: () => [],
        },
        activityUrl: {
            type: String,
            default: '/activity/',
        },
    },
    computed: {
        displayActivityItems() {
            return this.activityItems.slice(0, 3);
        },
    },
    methods: {
        activityIcon(tone = '') {
            if (tone === 'warning') {
                return 'mdi-archive-arrow-down-outline';
            }

            if (tone === 'info') {
                return 'mdi-upload-outline';
            }

            return 'mdi-database-check-outline';
        },
    },
};
</script>
